import React from 'react';

export default function ExploreSuccess({ title = 'Great. Mission ready.', description }) {
  return (
    <div className="explore-success">
      <span>✓</span>
      <div>
        <h3>{title}</h3>
        {description && <p>{description}</p>}
      </div>
    </div>
  );
}
